<div class="balance-special-users">
  @if (summaryCardsError()) {
    <div role="alert" class="summary-cards-error flex flex-col items-start gap-2 mb-4 color-neutral-900">
      <span>{{ 'balance.summaryCardsLoadError' | translate }}</span>
      <button type="button" class="color-secondary-600 underline" (click)="summaryCardsDataResource.reload()">
        {{ 'common.tryAgain' | translate }}
      </button>
    </div>
  }
  <!-- Desktop view -->
  <div class="hidden md:flex gap-5 items-start justify-start">
    <!-- First card -->
    <div class="card-flip-container flex-1 max-w-[21.4375rem] min-w-[6.8125rem]">
      <div class="card-flip">
        <!-- Front side -->
        <div class="card-front">
          <button
            class="bg-white box-border content-center flex flex-wrap gap-4 items-center justify-center p-[0.5rem] rounded-[0.5rem] shadow-[0rem_0.3125rem_0.9375rem_0rem_rgba(138,142,148,0.1)] transition-shadow duration-300 ease-in-out cursor-default w-full h-full"
          >
            <div class="flex flex-col gap-2 items-center justify-center min-h-0 min-w-0 text-center w-full">
              <div
                class="bg-[#e6f2fa] box-border flex gap-2 items-center justify-center p-[0.5rem] rounded-[3.125rem] size-14"
              >
                <div class="relative">
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="20" viewBox="0 0 28 20" fill="none">
                    <path
                      d="M12.2501 4C10.0409 4 8.25008 5.79087 8.25008 8C8.25008 10.2092 10.0409 12 12.2501 12C14.4593 12 16.2501 10.2092 16.2501 8C16.2501 5.79087 14.4593 4 12.2501 4ZM10.2501 8C10.2501 6.89547 11.1455 6 12.2501 6C13.3546 6 14.2501 6.89547 14.2501 8C14.2501 9.10453 13.3546 10 12.2501 10C11.1455 10 10.2501 9.10453 10.2501 8ZM0.916748 3C0.916748 1.34315 2.25989 0 3.91675 0H20.5834C22.2402 0 23.5834 1.34315 23.5834 3V13C23.5834 14.6568 22.2402 16 20.5834 16H3.91675C2.25989 16 0.916748 14.6568 0.916748 13V3ZM3.91675 2C3.36447 2 2.91675 2.44772 2.91675 3V4H3.91675C4.46903 4 4.91675 3.55228 4.91675 3V2H3.91675ZM2.91675 10H3.91675C5.5736 10 6.91675 11.3432 6.91675 13V14H17.5834V13C17.5834 11.3432 18.9266 10 20.5834 10H21.5834V6H20.5834C18.9266 6 17.5834 4.65685 17.5834 3V2H6.91675V3C6.91675 4.65685 5.5736 6 3.91675 6H2.91675V10ZM21.5834 4V3C21.5834 2.44772 21.1357 2 20.5834 2H19.5834V3C19.5834 3.55228 20.0311 4 20.5834 4H21.5834ZM21.5834 12H20.5834C20.0311 12 19.5834 12.4477 19.5834 13V14H20.5834C21.1357 14 21.5834 13.5523 21.5834 13V12ZM2.91675 13C2.91675 13.5523 3.36447 14 3.91675 14H4.91675V13C4.91675 12.4477 4.46903 12 3.91675 12H2.91675V13ZM4.11857 18C4.81019 19.1956 6.10288 20 7.58344 20H21.2501C24.7479 20 27.5834 17.1645 27.5834 13.6667V6.66667C27.5834 5.18613 26.779 3.89344 25.5834 3.20183V13.6667C25.5834 16.0599 23.6433 18 21.2501 18H4.11857Z"
                      fill="#007DCB"
                    />
                  </svg>
                </div>
              </div>
              <div class="flex flex-col items-start justify-start leading-[0] w-full">
                <div
                  class="font-bold overflow-ellipsis overflow-hidden text-[#003555] text-[1.9375rem] leading-[1.4] text-nowrap w-full"
                >
                  {{ summaryCardsDisplay()?.commission_monthly ?? '—' }}
                </div>
                <div class="font-normal text-[#005990] text-[0.9375rem] leading-[1.6] w-full">
                  {{ currentMonthCommissions() }}
                </div>
              </div>
            </div>
          </button>
        </div>
        <!-- Back side -->
        <div class="card-back">
          <div
            class="bg-[#e6f2fa] box-border content-stretch flex flex-wrap gap-4 items-center justify-start px-4 py-2 rounded-[0.5rem] shadow-[0rem_0.3125rem_0.9375rem_0rem_rgba(138,142,148,0.1)] w-full h-full"
          >
            <div
              class="basis-0 flex-col font-normal grow h-full justify-center leading-[0] min-h-px min-w-px overflow-ellipsis overflow-hidden text-[#007dcb] text-[0.9375rem]"
            >
              <p class="leading-[1.6]">{{ 'balance.commissionsTooltip' | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Second card -->
    <div class="card-flip-container flex-1 max-w-[21.4375rem] min-w-[6.8125rem]">
      <div class="card-flip">
        <!-- Front side -->
        <div class="card-front">
          <button
            class="bg-white box-border content-center flex flex-wrap gap-4 items-center justify-center p-[0.5rem] rounded-[0.5rem] shadow-[0rem_0.3125rem_0.9375rem_0rem_rgba(138,142,148,0.1)] transition-shadow duration-300 ease-in-out cursor-default w-full h-full"
          >
            <div class="flex flex-col gap-2 items-center justify-center min-h-0 min-w-0 text-center w-full">
              <div
                class="bg-[#fdf0e6] box-border flex gap-2 items-center justify-center p-[0.5rem] rounded-[3.125rem] size-14"
              >
                <div class="relative">
                  <svg width="32" height="30" viewBox="0 0 32 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M28.6939 17.1627C28.448 16.0252 27.5444 15.1878 26.3887 15.0253C25.6142 14.919 24.8273 15.1503 24.2188 15.6752L19.3625 20.1314H18.9199C19.2396 19.5127 19.258 18.7814 18.9629 18.1189C18.5634 17.2065 17.7028 16.6377 16.7131 16.6377H10.6458C9.69301 16.6377 8.7402 16.8627 7.87959 17.2877C7.59682 16.8752 7.13579 16.6377 6.63787 16.6377H4.9351C4.09908 16.6377 3.41675 17.319 3.41675 18.1502V25.3938C3.41675 26.2313 4.09908 26.9063 4.9351 26.9063H6.63787C7.10505 26.9063 7.53535 26.6938 7.82427 26.325L9.01067 26.9125C9.12747 26.9687 9.25041 27 9.3795 27H18.6986C19.9096 27 21.0468 26.5313 21.9013 25.675L27.8948 19.7002C28.5833 19.0189 28.8845 18.0439 28.6939 17.1565V17.1627ZM17.0881 19.7752L17.0266 19.8189C16.7192 20.0252 16.3688 20.1376 16.0062 20.1376H12.1826C11.7277 20.1376 11.3589 20.5064 11.3589 20.9564C11.3589 21.4064 11.7277 21.7751 12.1826 21.7751H19.676C19.885 21.7751 20.0879 21.6939 20.2354 21.5564L25.3007 16.9065C25.5404 16.7065 25.8416 16.619 26.1551 16.6565C26.6531 16.7252 27.0342 17.1252 27.0834 17.6252C27.1141 17.9377 26.985 18.2689 26.733 18.5189L20.721 24.5126C20.1862 25.05 19.4424 25.3563 18.6802 25.3563H9.56392L8.15007 24.6563V18.9939L8.75864 18.6877C9.29344 18.4189 9.88357 18.2814 10.4676 18.2814H16.5287C16.9897 18.2814 17.2602 18.6064 17.3524 18.8877C17.4446 19.1564 17.4139 19.5252 17.0758 19.7752H17.0881ZM6.50878 18.2877V25.2625H5.07034V18.2877H6.50878Z"
                      fill="#EF6401"
                    />
                    <path
                      d="M19.5688 9.83038C19.5688 11.5757 18.4332 12.7235 16.524 13.0537V13.7657C16.524 14.1974 16.174 14.5474 15.7422 14.5474V14.5474C15.3105 14.5474 14.9604 14.1974 14.9604 13.7657V13.1323C13.761 13.0584 12.8143 12.6755 11.9934 11.9685C11.5977 11.6277 11.6328 11.0251 12.0084 10.6622V10.6622C12.4266 10.2582 13.0912 10.3197 13.5524 10.6739C14.0873 11.0848 14.711 11.3241 15.4707 11.3241C16.6392 11.3241 17.3798 10.8524 17.3798 10.0033C17.3798 7.66054 11.965 8.8398 11.965 4.92464C11.9486 3.21078 13.1829 2.09441 14.9604 1.82711V1.11515C14.9604 0.683386 15.3105 0.333374 15.7422 0.333374V0.333374C16.174 0.333374 16.524 0.683386 16.524 1.11515V1.79566C17.3115 1.90314 18.0374 2.20161 18.6388 2.62079C19.0926 2.93712 19.0679 3.57926 18.6679 3.96139V3.96139C18.2581 4.35291 17.6193 4.3117 17.1456 4.0005C16.7205 3.72122 16.2757 3.57242 15.7998 3.57242C14.7136 3.57242 14.1046 3.96551 14.1046 4.75168C14.1046 6.87436 19.5688 5.77371 19.5688 9.83038Z"
                      fill="#EF6401"
                    />
                  </svg>
                </div>
              </div>
              <div class="flex flex-col items-start justify-start leading-[0] w-full">
                <div
                  class="font-bold overflow-ellipsis overflow-hidden text-[#003555] text-[1.9375rem] leading-[1.4] text-nowrap w-full"
                >
                  {{ summaryCardsDisplay()?.pending_payments ?? '—' }}
                </div>
                <div class="font-normal text-[#005990] text-[0.9375rem] leading-[1.6] w-full">
                  {{ 'balance.pendingPayments' | translate }}
                </div>
              </div>
            </div>
          </button>
        </div>
        <!-- Back side -->
        <div class="card-back">
          <div
            class="bg-[#fdf0e6] box-border content-stretch flex flex-wrap gap-4 items-center justify-start px-4 py-2 rounded-[0.5rem] shadow-[0rem_0.3125rem_0.9375rem_0rem_rgba(138,142,148,0.1)] w-full h-full"
          >
            <div
              class="basis-0 flex-col font-normal grow h-full justify-center leading-[0] min-h-px min-w-px overflow-ellipsis overflow-hidden text-[#EF6401] text-[0.9375rem]"
            >
              <p class="leading-[1.6]">{{ 'balance.pendingPaymentsTooltip' | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Third card -->
    <div class="card-flip-container flex-1 max-w-[21.4375rem] min-w-[6.8125rem]">
      <div class="card-flip">
        <!-- Front side -->
        <div class="card-front">
          <button
            class="bg-white box-border content-center flex flex-wrap gap-4 items-center justify-center p-[0.5rem] rounded-[0.5rem] shadow-[0rem_0.3125rem_0.9375rem_0rem_rgba(138,142,148,0.1)] transition-shadow duration-300 ease-in-out cursor-default w-full h-full"
          >
            <div class="flex flex-col gap-2 items-center justify-center min-h-0 min-w-0 text-center w-full">
              <div
                class="bg-[#e6f2f1] box-border flex gap-2 items-center justify-center p-[0.5rem] rounded-[3.125rem] size-14"
              >
                <div class="relative">
                  <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                    <path
                      d="M19.3909 4.79375C19.5093 4.64344 19.7297 4.62345 19.8733 4.75001L21.1013 5.83293L17.2344 10.6666H19.7956L22.6031 7.15725L24.806 9.09981C24.9415 9.21929 24.9572 9.42493 24.8413 9.56356L23.9197 10.6666H26.512C27.1707 9.7052 27.0204 8.38593 26.1288 7.59975L21.1961 3.24995C20.1915 2.36403 18.6488 2.5039 17.82 3.55608L12.2183 10.6666H14.7644L19.3909 4.79375ZM21.9167 20C21.3644 20 20.9167 20.4477 20.9167 21C20.9167 21.5522 21.3644 22 21.9167 22H24.5833C25.1356 22 25.5833 21.5522 25.5833 21C25.5833 20.4477 25.1356 20 24.5833 20H21.9167ZM6.25 11C6.25 10.4477 6.69772 9.99996 7.25 9.99996H11.4213L13.01 7.99996H7.25C5.59315 7.99996 4.25 9.34311 4.25 11V25C4.25 27.3932 6.19009 29.3333 8.58333 29.3333H24.5833C26.9765 29.3333 28.9167 27.3932 28.9167 25V16.3333C28.9167 13.9401 26.9765 12 24.5833 12H7.25C6.69772 12 6.25 11.5522 6.25 11ZM6.25 25V13.8293C6.56277 13.9398 6.89936 14 7.25 14H24.5833C25.872 14 26.9167 15.0446 26.9167 16.3333V25C26.9167 26.2886 25.872 27.3333 24.5833 27.3333H8.58333C7.29467 27.3333 6.25 26.2886 6.25 25Z"
                      fill="#017F70"
                    />
                  </svg>
                </div>
              </div>
              <div class="flex flex-col items-start justify-start leading-[0] w-full">
                <div
                  class="font-bold overflow-ellipsis overflow-hidden text-[#003555] text-[1.9375rem] leading-[1.4] text-nowrap w-full"
                >
                  {{ summaryCardsDisplay()?.paid_earnings ?? '—' }}
                </div>
                <div class="font-normal text-[#005990] text-[0.9375rem] leading-[1.6] w-full">
                  {{ 'balance.paidEarnings' | translate }}
                </div>
              </div>
            </div>
          </button>
        </div>
        <!-- Back side -->
        <div class="card-back">
          <div
            class="bg-[#e6f2f1] box-border content-stretch flex flex-wrap gap-4 items-center justify-start px-4 py-2 rounded-[0.5rem] shadow-[0rem_0.3125rem_0.9375rem_0rem_rgba(138,142,148,0.1)] w-full h-full"
          >
            <div
              class="basis-0 flex-col font-normal grow h-full justify-center leading-[0] min-h-px min-w-px overflow-ellipsis overflow-hidden text-[#017F70] text-[0.9375rem]"
            >
              <p class="leading-[1.6]">{{ 'balance.paidEarningsTooltip' | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Fourth card -->
    <div class="card-flip-container flex-1 max-w-[21.4375rem] min-w-[6.8125rem]">
      <div class="card-flip">
        <!-- Front side -->
        <div class="card-front">
          <button
            class="bg-white box-border content-center flex flex-wrap gap-4 items-center justify-center p-[0.5rem] rounded-[0.5rem] shadow-[0rem_0.3125rem_0.9375rem_0rem_rgba(138,142,148,0.1)] transition-shadow duration-300 ease-in-out cursor-default w-full h-full"
          >
            <div class="flex flex-col gap-2 items-center justify-center min-h-0 min-w-0 text-center w-full">
              <div
                class="bg-[#f6e9ef] box-border flex gap-2 items-center justify-center p-[0.5rem] rounded-[3.125rem] size-14"
              >
                <div class="relative">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="28" viewBox="0 0 20 28" fill="none">
                    <path
                      d="M10.0554 5.52429L11.2722 7.99487L13.9974 8.38875C14.2765 8.42907 14.3881 8.7721 14.1861 8.96892L12.215 10.8898L12.6803 13.6041C12.7279 13.882 12.4362 14.0939 12.1867 13.9624L9.75041 12.679L7.31396 13.9624C7.06444 14.0939 6.77254 13.8819 6.82043 13.6038L7.2881 10.8898L5.31471 8.96906C5.11254 8.7723 5.22404 8.42908 5.50323 8.38875L8.22851 7.99487L9.44534 5.52429C9.57001 5.2712 9.93082 5.2712 10.0554 5.52429ZM19.0838 10.0018C19.0838 4.84642 14.9051 0.667114 9.75028 0.667114C4.59552 0.667114 0.416748 4.84642 0.416748 10.0018C0.416748 12.5449 1.43352 14.8504 3.08263 16.5339L3.08454 26.3379L3.09379 26.4772C3.19113 27.2008 4.03681 27.5947 4.66037 27.1556L9.74908 23.5715L14.8404 27.1557L14.9597 27.2284C15.6072 27.5653 16.416 27.1005 16.416 26.3379L16.4179 16.5339C18.067 14.8504 19.0838 12.5449 19.0838 10.0018ZM14.4162 18.0882L14.416 24.4108L10.3244 21.5305L10.19 21.4506C9.86575 21.2911 9.47521 21.3178 9.17307 21.5306L5.08458 24.4103L5.08429 18.0882C6.45696 18.8821 8.05051 19.3366 9.75028 19.3366C11.45 19.3366 13.0436 18.8821 14.4162 18.0882ZM2.41679 10.0018C2.41679 5.95114 5.7001 2.66741 9.75028 2.66741C13.8005 2.66741 17.0838 5.95114 17.0838 10.0018C17.0838 14.0526 13.8005 17.3363 9.75028 17.3363C5.7001 17.3363 2.41679 14.0526 2.41679 10.0018Z"
                      fill="#A22561"
                    />
                  </svg>
                </div>
              </div>
              <div class="flex flex-col items-start justify-start leading-[0] w-full">
                <div
                  class="font-bold overflow-ellipsis overflow-hidden text-[#003555] text-[1.9375rem] leading-[1.4] text-nowrap w-full"
                >
                  {{ summaryCardsDisplay()?.promotion_funds ?? '—' }}
                </div>
                <div class="font-normal text-[#005990] text-[0.9375rem] leading-[1.6] w-full">
                  {{ 'balance.promotionFunds' | translate }}
                </div>
              </div>
            </div>
          </button>
        </div>
        <!-- Back side -->
        <div class="card-back">
          <div
            class="bg-[#f6e9ef] box-border content-stretch flex flex-wrap gap-4 items-center justify-start px-4 py-2 rounded-[0.5rem] shadow-[0rem_0.3125rem_0.9375rem_0rem_rgba(138,142,148,0.1)] w-full h-full"
          >
            <div
              class="basis-0 flex-col font-normal grow h-full justify-center leading-[0] min-h-px min-w-px overflow-ellipsis overflow-hidden text-[#A22561] text-[0.9375rem]"
            >
              <p class="leading-[1.6]">{{ 'balance.promotionFundsTooltip' | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile view -->
  <div class="grid grid-cols-2 md:hidden gap-2">
    <div
      class="bg-white box-border content-center flex flex-wrap gap-4 items-center justify-start p-[1rem] rounded-[0.5rem] shadow-[0rem_0.3125rem_0.9375rem_0rem_rgba(138,142,148,0.1)] w-full"
    >
      <div class="basis-0 flex gap-4 grow items-center justify-start min-h-0 min-w-0">
        <div
          class="bg-[#e6f2fa] box-border flex gap-2 items-center justify-center p-[0.5rem] rounded-[3.125rem] size-10"
        >
          <div class="relative">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
              <path
                d="M8.5 3.49548C6.84315 3.49548 5.5 4.83863 5.5 6.49548C5.5 8.15238 6.84315 9.49548 8.5 9.49548C10.1569 9.49548 11.5 8.15238 11.5 6.49548C11.5 4.83863 10.1569 3.49548 8.5 3.49548ZM7 6.49548C7 5.66708 7.67157 4.99548 8.5 4.99548C9.3284 4.99548 10 5.66708 10 6.49548C10 7.32388 9.3284 7.99548 8.5 7.99548C7.67157 7.99548 7 7.32388 7 6.49548ZM0 2.74548C0 1.50284 1.00736 0.495483 2.25 0.495483H14.75C15.9926 0.495483 17 1.50284 17 2.74548V10.2455C17 11.4881 15.9926 12.4955 14.75 12.4955H2.25C1.00736 12.4955 0 11.4881 0 10.2455V2.74548ZM2.25 1.99548C1.83579 1.99548 1.5 2.33127 1.5 2.74548V3.49548H2.25C2.66421 3.49548 3 3.15969 3 2.74548V1.99548H2.25ZM1.5 7.99548H2.25C3.49264 7.99548 4.5 9.00288 4.5 10.2455V10.9955H12.5V10.2455C12.5 9.00288 13.5074 7.99548 14.75 7.99548H15.5V4.99548H14.75C13.5074 4.99548 12.5 3.98812 12.5 2.74548V1.99548H4.5V2.74548C4.5 3.98812 3.49264 4.99548 2.25 4.99548H1.5V7.99548ZM15.5 3.49548V2.74548C15.5 2.33127 15.1642 1.99548 14.75 1.99548H14V2.74548C14 3.15969 14.3358 3.49548 14.75 3.49548H15.5ZM15.5 9.49548H14.75C14.3358 9.49548 14 9.83128 14 10.2455V10.9955H14.75C15.1642 10.9955 15.5 10.6597 15.5 10.2455V9.49548ZM1.5 10.2455C1.5 10.6597 1.83579 10.9955 2.25 10.9955H3V10.2455C3 9.83128 2.66421 9.49548 2.25 9.49548H1.5V10.2455ZM2.40137 13.9955C2.92008 14.8922 3.8896 15.4955 5.00002 15.4955H15.25C17.8734 15.4955 20 13.3689 20 10.7455V5.49548C20 4.38508 19.3967 3.41556 18.5 2.89685V10.7455C18.5 12.5404 17.0449 13.9955 15.25 13.9955H2.40137Z"
                fill="#007DCB"
              />
            </svg>
          </div>
        </div>
        <div class="basis-0 flex flex-col grow items-start justify-start leading-[0] min-h-0 min-w-0">
          <div
            class="font-normal max-h-12 overflow-ellipsis overflow-hidden text-[#005990] text-[0.8125rem] leading-[1.6] w-full"
          >
            {{ currentMonthCommissions() }}
          </div>
          <div
            class="font-bold overflow-ellipsis overflow-hidden text-[#003555] text-[1.1875rem] leading-[1.6] text-nowrap w-full"
          >
            {{ summaryCardsDisplay()?.commission_monthly ?? '—' }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="bg-white box-border content-center flex flex-wrap gap-4 items-center justify-start p-[1rem] rounded-[0.5rem] shadow-[0rem_0.3125rem_0.9375rem_0rem_rgba(138,142,148,0.1)] w-full"
    >
      <div class="basis-0 flex gap-4 grow items-center justify-start min-h-0 min-w-0">
        <div
          class="bg-[#fdf0e6] box-border flex gap-2 items-center justify-center p-[0.5rem] rounded-[3.125rem] size-10"
        >
          <div class="relative">
            <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20.9579 12.6175C20.7735 11.7644 20.0957 11.1363 19.229 11.0144C18.6481 10.9347 18.0579 11.1082 17.6015 11.5019L13.9593 14.844H13.6274C13.8671 14.38 13.8809 13.8316 13.6596 13.3347C13.36 12.6503 12.7145 12.2238 11.9722 12.2238H7.42181C6.7072 12.2238 5.99259 12.3925 5.34713 12.7113C5.13506 12.4019 4.78928 12.2238 4.41584 12.2238H3.13876C2.51175 12.2238 2 12.7347 2 13.3581V18.7908C2 19.4189 2.51175 19.9252 3.13876 19.9252H4.41584C4.76623 19.9252 5.08895 19.7658 5.30564 19.4892L6.19544 19.9299C6.28304 19.972 6.37525 19.9955 6.47207 19.9955H13.4614C14.3696 19.9955 15.2226 19.6439 15.8634 19.0018L20.3585 14.5206C20.8749 14.0097 21.1008 13.2784 20.9579 12.6128V12.6175ZM12.2535 14.5769L12.2074 14.6097C11.9769 14.7643 11.7141 14.8487 11.4421 14.8487H8.5744C8.23323 14.8487 7.95661 15.1253 7.95661 15.4628C7.95661 15.8003 8.23323 16.0768 8.5744 16.0768H14.1945C14.3512 16.0768 14.5033 16.0159 14.614 15.9128L18.4129 12.4253C18.5928 12.2753 18.8187 12.2097 19.0538 12.2378C19.4272 12.2894 19.7131 12.5894 19.75 12.9644C19.773 13.1988 19.6762 13.4472 19.4872 13.6347L14.9782 18.1299C14.5771 18.533 14.0193 18.7627 13.4476 18.7627H6.61038L5.54999 18.2377V13.9909L6.00642 13.7612C6.40752 13.5597 6.85012 13.4566 7.2881 13.4566H11.8339C12.1797 13.4566 12.3826 13.7003 12.4517 13.9112C12.5209 14.1128 12.4978 14.3894 12.2443 14.5769H12.2535ZM4.31902 13.4613V18.6924H3.24019V13.4613H4.31902Z"
                fill="#EF6401"
              />
              <path
                d="M14.114 7.11824C14.114 8.42722 13.2623 9.28808 11.8304 9.53573V10.0697C11.8304 10.3935 11.5679 10.656 11.2441 10.656C10.9203 10.656 10.6578 10.3935 10.6578 10.0697V9.59469C9.7582 9.53925 9.04813 9.25208 8.43251 8.72184C8.13572 8.46621 8.16203 8.01429 8.44372 7.74212C8.75736 7.43908 9.25586 7.48521 9.60171 7.75089C10.0029 8.05909 10.4707 8.23854 11.0404 8.23854C11.9168 8.23854 12.4723 7.88476 12.4723 7.24796C12.4723 5.49085 8.4112 6.3753 8.4112 3.43893C8.39886 2.15354 9.32464 1.31626 10.6578 1.11578V0.581814C10.6578 0.257992 10.9203 -0.0045166 11.2441 -0.0045166C11.5679 -0.0045166 11.8304 0.257992 11.8304 0.581814V1.0922C12.421 1.1728 12.9655 1.39666 13.4166 1.71104C13.7569 1.94829 13.7384 2.4299 13.4384 2.7165C13.131 3.01014 12.6519 2.97923 12.2967 2.74583C11.9778 2.53637 11.6442 2.42477 11.2873 2.42477C10.4726 2.42477 10.0159 2.71958 10.0159 3.30922C10.0159 4.90122 14.114 4.07574 14.114 7.11824Z"
                fill="#EF6401"
              />
            </svg>
          </div>
        </div>
        <div class="basis-0 flex flex-col grow items-start justify-start leading-[0] min-h-0 min-w-0">
          <div
            class="font-normal max-h-12 overflow-ellipsis overflow-hidden text-[#005990] text-[0.8125rem] leading-[1.6] w-full"
          >
            {{ 'balance.pendingPayments' | translate }}
          </div>
          <div
            class="font-bold overflow-ellipsis overflow-hidden text-[#003555] text-[1.1875rem] leading-[1.6] text-nowrap w-full"
          >
            {{ summaryCardsDisplay()?.pending_payments ?? '—' }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="bg-white box-border content-center flex flex-wrap gap-4 items-center justify-start p-[1rem] rounded-[0.5rem] shadow-[0rem_0.3125rem_0.9375rem_0rem_rgba(138,142,148,0.1)] w-full"
    >
      <div class="basis-0 flex gap-4 grow items-center justify-start min-h-0 min-w-0">
        <div
          class="bg-[#e6f2f1] box-border flex gap-2 items-center justify-center p-[0.5rem] rounded-[3.125rem] size-10"
        >
          <div class="relative">
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
              <path
                d="M11.3557 1.59082C11.4445 1.47809 11.6098 1.4631 11.7175 1.55802L12.6385 2.37021L9.7383 5.99548H11.6592L13.7648 3.36345L15.417 4.82037C15.5186 4.90998 15.5304 5.06421 15.4435 5.16818L14.7523 5.99548H16.6965C17.1905 5.27441 17.0778 4.28496 16.4091 3.69532L12.7096 0.432974C11.9561 -0.231466 10.7991 -0.126558 10.1775 0.662574L5.9762 5.99548H7.8858L11.3557 1.59082ZM13.25 12.9955C12.8358 12.9955 12.5 13.3313 12.5 13.7455C12.5 14.1597 12.8358 14.4955 13.25 14.4955H15.25C15.6642 14.4955 16 14.1597 16 13.7455C16 13.3313 15.6642 12.9955 15.25 12.9955H13.25ZM1.5 6.24548C1.5 5.83127 1.83579 5.49548 2.25 5.49548H5.37844L6.57 3.99548H2.25C1.00736 3.99548 0 5.00284 0 6.24548V16.7455C0 18.5404 1.45507 19.9955 3.25 19.9955H15.25C17.0449 19.9955 18.5 18.5404 18.5 16.7455V10.2455C18.5 8.45055 17.0449 6.99548 15.25 6.99548H2.25C1.83579 6.99548 1.5 6.65969 1.5 6.24548ZM1.5 16.7455V8.36745C1.73458 8.45036 1.98702 8.49548 2.25 8.49548H15.25C16.2165 8.49548 17 9.27898 17 10.2455V16.7455C17 17.712 16.2165 18.4955 15.25 18.4955H3.25C2.2835 18.4955 1.5 17.712 1.5 16.7455Z"
                fill="#017F70"
              />
            </svg>
          </div>
        </div>
        <div class="basis-0 flex flex-col grow items-start justify-start leading-[0] min-h-0 min-w-0">
          <div
            class="font-normal max-h-12 overflow-ellipsis overflow-hidden text-[#005990] text-[0.8125rem] leading-[1.6] w-full whitespace-pre-wrap"
          >
            {{ 'balance.paidEarnings' | translate }}
          </div>
          <div
            class="font-bold overflow-ellipsis overflow-hidden text-[#003555] text-[1.1875rem] leading-[1.6] text-nowrap w-full"
          >
            {{ summaryCardsDisplay()?.paid_earnings ?? '—' }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="bg-white box-border content-center flex flex-wrap gap-4 items-center justify-start p-[1rem] rounded-[0.5rem] shadow-[0rem_0.3125rem_0.9375rem_0rem_rgba(138,142,148,0.1)] w-full"
    >
      <div class="basis-0 flex gap-4 grow items-center justify-start min-h-0 min-w-0">
        <div
          class="bg-[#f6e9ef] box-border flex gap-2 items-center justify-center p-[0.5rem] rounded-[3.125rem] size-10"
        >
          <div class="relative">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 20" fill="none">
              <path
                d="M7.22907 3.63861L8.14169 5.49155L10.1856 5.78695C10.3949 5.8172 10.4786 6.07446 10.3271 6.22209L8.84881 7.66276L9.19782 9.69847C9.23352 9.90691 9.01471 10.0658 8.82761 9.96721L7.00037 9.00467L5.17303 9.96721C4.98589 10.0658 4.76696 9.90681 4.80288 9.69827L5.15363 7.66276L3.67359 6.22219C3.52197 6.07461 3.60559 5.81721 3.81498 5.78695L5.85895 5.49155L6.77157 3.63861C6.86507 3.44879 7.13567 3.44879 7.22907 3.63861ZM14.0004 6.99677C14.0004 3.1302 10.8664 -0.00427246 7.00027 -0.00427246C3.1342 -0.00427246 0.00012207 3.1302 0.00012207 6.99677C0.00012207 8.90406 0.762698 10.6332 1.99953 11.8958L2.00096 19.2488L2.0079 19.3533C2.08091 19.896 2.71517 20.1914 3.18284 19.8621L6.99937 17.174L10.8179 19.8622L10.9074 19.9167C11.393 20.1693 11.9996 19.8208 11.9996 19.2488L12.001 11.8958C13.2378 10.6332 14.0004 8.90406 14.0004 6.99677ZM10.4997 13.0616L10.4995 17.8035L7.43088 15.6433L7.33008 15.5834C7.08687 15.4637 6.79396 15.4837 6.56736 15.6434L3.501 17.8031L3.50078 13.0616C4.53028 13.657 5.72544 13.9978 7.00027 13.9978C8.2751 13.9978 9.47022 13.657 10.4997 13.0616ZM1.50015 6.99677C1.50015 3.95875 3.96264 1.49595 7.00027 1.49595C10.0379 1.49595 12.5004 3.95875 12.5004 6.99677C12.5004 10.0348 10.0379 12.4976 7.00027 12.4976C3.96264 12.4976 1.50015 10.0348 1.50015 6.99677Z"
                fill="#A22561"
              />
            </svg>
          </div>
        </div>
        <div class="basis-0 flex flex-col grow items-start justify-start leading-[0] min-h-0 min-w-0">
          <div
            class="font-normal max-h-12 overflow-ellipsis overflow-hidden text-[#005990] text-[0.8125rem] leading-[1.6] w-full"
          >
            {{ 'balance.promotionFunds' | translate }}
          </div>
          <div
            class="font-bold overflow-ellipsis overflow-hidden text-[#003555] text-[1.1875rem] leading-[1.6] text-nowrap w-full"
          >
            {{ summaryCardsDisplay()?.promotion_funds ?? '—' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<korviu-button
  color="tertiary"
  class="month-commissions-button mt-[1.5rem] mb-[2rem] block"
  (onclick)="onViewMonthCommissionsClick()"
>
  @if (currentPaymentMonthLabel()) {
    {{ 'balance.viewMonthCommissions' | translate: { month: currentPaymentMonthLabel() } }}
  } @else {
    {{ 'balance.viewCurrentMonthCommissions' | translate }}
  }
</korviu-button>

<!-- Earnings Growth Chart -->
<div
  class="bg-white box-border content-stretch flex flex-col gap-4 items-start justify-start p-6 rounded-[0.25rem] shadow-[0rem_0.3125rem_0.9375rem_0rem_rgba(138,142,148,0.1)] w-full"
>
  <!-- Header -->
  <div class="content-stretch flex flex-col items-start justify-start w-full">
    <div class="font-bold text-[#505760] text-[1.625rem] leading-[1.6] w-full">
      {{ 'balance.earningsGrowth' | translate }}
    </div>
    <div class="font-normal text-[#737980] text-[1.125rem] leading-[1.6] w-full">
      {{ 'balance.last6Months' | translate }}
    </div>
  </div>

  @if (earningsGrowthGraphError()) {
    <div role="alert" class="earnings-growth-error flex flex-col items-start gap-2 color-neutral-900">
      <span>{{ 'balance.earningsGrowthLoadError' | translate }}</span>
      <button type="button" class="color-secondary-600 underline" (click)="earningsGrowthGraphResource.reload()">
        {{ 'common.tryAgain' | translate }}
      </button>
    </div>
  } @else if (hasEarningsGrowthData()) {
    <!-- Chart Container -->
    <div class="content-stretch flex flex-col gap-2 items-start justify-start w-full">
      <div class="box-border content-stretch flex flex-col items-center justify-center overflow-hidden w-full">
        <apx-chart
          class="w-full max-w-[29rem]"
          [series]="earningsGrowthChartOptions().series"
          [chart]="earningsGrowthChartOptions().chart"
          [xaxis]="earningsGrowthChartOptions().xaxis"
          [yaxis]="earningsGrowthChartOptions().yaxis"
          [plotOptions]="earningsGrowthChartOptions().plotOptions"
          [dataLabels]="earningsGrowthChartOptions().dataLabels"
          [colors]="earningsGrowthChartOptions().colors"
          [grid]="earningsGrowthChartOptions().grid"
          [tooltip]="earningsGrowthChartOptions().tooltip"
          [responsive]="earningsGrowthChartOptions().responsive"
          [legend]="earningsGrowthChartOptions().legend"
          [states]="earningsGrowthChartOptions().states"
        />
      </div>
    </div>

    <!-- Footer with trend info -->
    <div class="content-stretch flex flex-col items-start justify-center w-full">
      @if (earningsTrendTranslationKey(); as trendKey) {
        <div class="content-stretch flex gap-1 items-center justify-start">
          <div class="font-normal text-[#505760] text-[1.125rem] leading-[1.6]">
            {{ trendKey | translate: { percentage: earningsTrendPercentage() } }}
          </div>
          <div class="overflow-hidden" [style.transform]="earningsTrendIsUp() ? null : 'scaleY(-1)'">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              class="size-full"
            >
              <path
                d="M13.7489 6L21.3027 6.00052L21.403 6.01444L21.5018 6.04205L21.5621 6.0676C21.6413 6.10246 21.7155 6.15315 21.7808 6.21836L21.8215 6.2624L21.865 6.31878L21.9192 6.4089L21.9579 6.49922L21.977 6.5633L21.9906 6.6273L22 6.7215L22.0004 14.2539C22.0004 14.6681 21.6647 15.0039 21.2504 15.0039C20.8708 15.0039 20.557 14.7217 20.5073 14.3557L20.5004 14.2539L20.5 8.559L12.7812 16.2793C12.5149 16.5455 12.0982 16.5698 11.8046 16.3519L11.7205 16.2793L8.75001 13.3089L3.28033 18.7786C2.98744 19.0715 2.51256 19.0715 2.21967 18.7786C1.9534 18.5123 1.9292 18.0957 2.14705 17.8021L2.21967 17.7179L8.21967 11.7179C8.48593 11.4517 8.90259 11.4275 9.1962 11.6453L9.28032 11.7179L12.2508 14.6883L19.438 7.5H13.7489C13.3692 7.5 13.0554 7.21785 13.0058 6.85177L12.9989 6.75C12.9989 6.3703 13.2811 6.05651 13.6472 6.00685L13.7489 6Z"
                [attr.fill]="earningsTrendIsUp() ? '#078339' : '#cb2222'"
              />
            </svg>
          </div>
        </div>
      }
      <div class="font-normal text-[#737980] text-[0.9375rem] leading-[1.6]">
        {{ 'balance.showingMonthlyCommissions' | translate }}
      </div>
    </div>
  } @else if (!earningsGrowthGraphLoading()) {
    <div class="flex flex-col gap-4 items-center w-full py-6">
      <korviu-no-data />
      <div class="text-[#737980] text-[0.9375rem]">{{ 'balance.youHaveNoEarningsYetShort' | translate }}</div>
    </div>
  }
</div>

<app-tabs-v2 [tabs]="paymentTabs()" [(selectedTab)]="selectedPaymentTab" class="w-full my-[2.5rem] block" />

@if (selectedPaymentTab() === PaymentTab.PAYMENTS) {
  <!-- payments widget -->
  <div
    class="w-full flex p-4 md:p-6 rounded-lg gap-3 payments-widget payment-summary"
    [attr.aria-busy]="nextPaymentLoading()"
  >
    @if (nextPaymentError()) {
      <div role="alert" class="next-payment-error flex flex-col items-start gap-2 color-neutral-900">
        <span>{{ 'balance.nextPaymentLoadError' | translate }}</span>
        <button type="button" class="color-secondary-600 underline" (click)="nextPaymentResource.reload()">
          {{ 'common.tryAgain' | translate }}
        </button>
      </div>
    } @else {
      <div class="flex flex-col items-center gap-1 flex-1 justify-center payment-summary-item">
        <ng-component [ngTemplateOutlet]="nextPaymentIconTpl"></ng-component>
        <div class="text-[1rem]/[1.6rem] font-light color-success-600 payment-summary-title">
          {{ 'balance.nextPayment' | translate }}
        </div>
        <div class="text-[1.375rem]/[2.2rem] font-bold color-success-900 payment-summary-value">
          {{ nextPaymentAmountLabel() }}
        </div>
        @if (nextPaymentStatusTranslationKey(); as statusKey) {
          <app-tag [type]="nextPaymentStatusTagType()">{{ statusKey | translate }}</app-tag>
        }
      </div>
      <div class="w-[1px] background-neutral-50 payment-summary-divider"></div>
      <div class="flex flex-col items-center gap-1 flex-1 justify-center payment-summary-item">
        <ng-component [ngTemplateOutlet]="paymentPeriodIconTpl"></ng-component>
        <div class="text-[1rem]/[1.6rem] font-light color-secondary-600 payment-summary-title">
          {{ 'balance.paymentPeriod' | translate }}
        </div>
        <div class="text-[1.375rem]/[2.2rem] font-bold color-secondary-900 payment-summary-value">
          {{ nextPaymentPeriodLabel() || '—' }}
        </div>
      </div>
      <div class="w-[1px] background-neutral-50 payment-summary-divider"></div>
      <div class="flex flex-col items-center gap-1 flex-1 justify-center payment-summary-item">
        <ng-component [ngTemplateOutlet]="paymentDueDateIconTpl"></ng-component>
        <div class="text-[1rem]/[1.6rem] font-light color-warning-600 payment-summary-title">
          {{ 'balance.paymentDueDate' | translate }}
        </div>
        <div class="text-[1.375rem]/[2.2rem] font-bold color-warning-900 payment-summary-value">
          {{ nextPaymentDueDateLabel() || '—' }}
        </div>
      </div>
    }
  </div>
  <div class="mt-10 mb-10 w-full">
    <korviu-list [config]="korviuListConfig" class="payments">
      <div *emptyTemplate class="flex flex-col gap-8 items-center px-4">
        <korviu-no-data />
        <div class="text-[#737980] text-[0.9375rem]">{{ 'balance.paymentsAccumulate' | translate }}</div>
      </div>
    </korviu-list>
  </div>
} @else {
  <div class="flex flex-col gap-4">
    <div class="flex gap-4">
      <korviu-date-picker
        class="flex-1"
        [control]="startDateControl"
        [label]="'my-forest.startDate' | translate"
        dateFormat="dd MMM yyyy"
        mode="date"
        (dateSelected)="onStartDateSelected()"
      />
      <korviu-date-picker
        #endDatePicker
        class="flex-1"
        [control]="endDateControl"
        [defaultPickerValue]="startDateControl.value"
        [label]="'my-forest.endDate' | translate"
        dateFormat="dd MMM yyyy"
        mode="date"
      />
    </div>

    <korviu-list [config]="transactionListConfig" #transactionList>
      <div *emptyTemplate class="flex flex-col gap-8 items-center py-[3.5rem]">
        <i>
          <svg xmlns="http://www.w3.org/2000/svg" width="88" height="88" viewBox="0 0 88 88" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M82.75 0.625C85.3043 0.625 87.375 2.69568 87.375 5.25V82.75C87.375 85.3043 85.3043 87.375 82.75 87.375H5.25C2.69568 87.375 0.625 85.3043 0.625 82.75V5.25C0.625 2.69568 2.69568 0.625 5.25 0.625H82.75ZM2.125 82.75C2.125 84.4759 3.52411 85.875 5.25 85.875H82.75C84.4759 85.875 85.875 84.4759 85.875 82.75V60.25H68.8535C68.0775 60.2504 67.3315 60.5395 66.7588 61.0576L66.6465 61.1641L57.2881 70.5225C56.4215 71.3879 55.2472 71.8743 54.0225 71.875H33.9775C32.7528 71.8743 31.5785 71.3879 30.7119 70.5225L21.3535 61.1641C20.8044 60.6156 20.0723 60.2924 19.3008 60.2539L19.1465 60.25H2.125V82.75ZM5.25 2.125C3.52411 2.125 2.125 3.52411 2.125 5.25V58.75H19.1475L19.376 58.7559C20.5175 58.8129 21.6006 59.2911 22.4131 60.1025L31.7715 69.4609L31.8838 69.5674C32.4565 70.0855 33.2025 70.3746 33.9785 70.375H54.0215L54.1758 70.3711C54.9473 70.3326 55.6794 70.0094 56.2285 69.4609L65.5869 60.1025L65.7529 59.9453C66.6005 59.1786 67.7043 58.7506 68.8525 58.75H85.875V5.25C85.875 3.52411 84.4759 2.125 82.75 2.125H5.25Z"
              fill="#C9CBCE"
            />
          </svg>
        </i>
        <div class="text-[#737980] text-[0.9375rem]">{{ transactionEmptyMessageKey() | translate }}</div>
      </div>
    </korviu-list>
  </div>
}
<!-- Payment Support Section -->
<div class="content-stretch flex flex-col gap-6 items-start justify-start w-full mt-[3.5rem]">
  <div
    class="font-normal relative shrink-0 text-[#505760] text-[1.125rem] text-center leading-[1.6] w-full max-w-[49.375rem]"
  >
    {{ 'balance.wereHereToHelp' | translate }}
  </div>
  <button
    (click)="onContactUsClick()"
    class="bg-[#007dcb] box-border flex gap-2 h-[3.3125rem] items-center justify-center px-6 py-3 w-full rounded-[0.75rem] shadow-[0px_0px_0.3125rem_0px_rgba(138,142,148,0.2)] hover:shadow-[0px_0px_0.3125rem_0px_rgba(138,142,148,0.4)] transition-shadow duration-300 ease-in-out"
  >
    <span class="font-normal text-[#fcfcfc] text-[1.125rem] text-center text-nowrap leading-[1.6]">
      {{ 'balance.contactUs' | translate }}
    </span>
  </button>
</div>

<ng-template #nextPaymentIconTpl>
  <i nz-icon class="flex items-center justify-center">
    <svg width="33" height="23" viewBox="0 0 33 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Group 1000003269">
        <g id="Group 1000003268">
          <rect
            id="Rectangle 61"
            x="1.16898"
            y="1.59257"
            width="30.33"
            height="20.1482"
            rx="1.165"
            stroke="#0D9443"
            stroke-width="1.67"
          />
          <path
            id="Rectangle 62"
            d="M25.0605 2.21216V4.57579C25.0605 5.68036 25.956 6.5758 27.0605 6.5758H30.8787"
            stroke="#0D9443"
          />
          <path
            id="Rectangle 63"
            d="M7.60742 2.21216V4.57579C7.60742 5.68036 6.71199 6.5758 5.60742 6.5758H1.78924"
            stroke="#0D9443"
          />
          <path
            id="Rectangle 64"
            d="M25.0605 21.1211V18.7575C25.0605 17.6529 25.956 16.7575 27.0605 16.7575H30.8787"
            stroke="#0D9443"
          />
          <path
            id="Rectangle 65"
            d="M7.60742 21.1211V18.7575C7.60742 17.6529 6.71199 16.7575 5.60742 16.7575H1.78924"
            stroke="#0D9443"
          />
        </g>
        <g id="USD">
          <path
            id="Vector"
            d="M19.4883 15.1845V8.14893H22.4527C24.6563 8.14893 26.2669 9.53232 26.2669 11.6667C26.2669 13.7912 24.6563 15.1845 22.4725 15.1845H19.4883ZM22.4527 9.82877H21.4646V13.5047H22.4527C23.5594 13.5047 24.2511 12.892 24.2511 11.6568C24.2511 10.4315 23.5495 9.82877 22.4527 9.82877Z"
            fill="#0D9443"
          />
          <path
            id="Vector_2"
            d="M15.7398 15.303C14.5343 15.303 13.6943 14.967 12.9434 14.2062L14.1785 12.971C14.6924 13.4651 15.2457 13.722 15.8979 13.722C16.4414 13.722 16.7181 13.5441 16.7181 13.2575C16.7181 12.2496 13.4473 12.6548 13.4473 10.2239C13.4473 8.86031 14.4849 8.03027 16.0857 8.03027C17.1331 8.03027 18.0817 8.386 18.6746 8.99865L17.4295 10.2338C16.9947 9.80893 16.5797 9.6113 16.0659 9.6113C15.6509 9.6113 15.394 9.73976 15.394 10.0066C15.394 10.9651 18.6647 10.5402 18.6647 13.05C18.6647 14.4828 17.5975 15.303 15.7398 15.303Z"
            fill="#0D9443"
          />
          <path
            id="Vector_3"
            d="M9.44433 15.3031C7.58662 15.3031 6.36133 14.0679 6.36133 12.3288V8.14893H8.33761V12.5066C8.33761 13.1885 8.8218 13.5639 9.44433 13.5639C10.0669 13.5639 10.5214 13.1885 10.5214 12.5165V8.14893H12.5076V12.3386C12.5076 14.0778 11.302 15.3031 9.44433 15.3031Z"
            fill="#0D9443"
          />
        </g>
      </g>
    </svg>
  </i>
</ng-template>
<ng-template #paymentPeriodIconTpl>
  <i nz-icon>
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Stroke Icons">
        <path
          id="Vector"
          d="M23.6667 4C26.0599 4 28 5.94009 28 8.33333V23.6667C28 26.0599 26.0599 28 23.6667 28H8.33333C5.94009 28 4 26.0599 4 23.6667V8.33333C4 5.94009 5.94009 4 8.33333 4H23.6667ZM26 11.3333H6V23.6667C6 24.9553 7.04467 26 8.33333 26H23.6667C24.9553 26 26 24.9553 26 23.6667V11.3333ZM10.3333 19.3333C11.2538 19.3333 12 20.0795 12 21C12 21.9205 11.2538 22.6667 10.3333 22.6667C9.41285 22.6667 8.66667 21.9205 8.66667 21C8.66667 20.0795 9.41285 19.3333 10.3333 19.3333ZM16 19.3333C16.9205 19.3333 17.6667 20.0795 17.6667 21C17.6667 21.9205 16.9205 22.6667 16 22.6667C15.0795 22.6667 14.3333 21.9205 14.3333 21C14.3333 20.0795 15.0795 19.3333 16 19.3333ZM10.3333 14C11.2538 14 12 14.7461 12 15.6667C12 16.5872 11.2538 17.3333 10.3333 17.3333C9.41285 17.3333 8.66667 16.5872 8.66667 15.6667C8.66667 14.7461 9.41285 14 10.3333 14ZM16 14C16.9205 14 17.6667 14.7461 17.6667 15.6667C17.6667 16.5872 16.9205 17.3333 16 17.3333C15.0795 17.3333 14.3333 16.5872 14.3333 15.6667C14.3333 14.7461 15.0795 14 16 14ZM21.6667 14C22.5872 14 23.3333 14.7461 23.3333 15.6667C23.3333 16.5872 22.5872 17.3333 21.6667 17.3333C20.7461 17.3333 20 16.5872 20 15.6667C20 14.7461 20.7461 14 21.6667 14ZM23.6667 6H8.33333C7.04467 6 6 7.04467 6 8.33333V9.33333H26V8.33333C26 7.04467 24.9553 6 23.6667 6Z"
          fill="#007DCB"
        />
      </g>
    </svg>
  </i>
</ng-template>
<ng-template #paymentDueDateIconTpl>
  <i nz-icon>
    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Stroke Icons">
        <path
          id="Vector"
          d="M21.3346 18.3333C21.3346 17.7811 21.7824 17.3333 22.3346 17.3333H25.0013C25.5536 17.3333 26.0013 17.7811 26.0013 18.3333C26.0013 18.8856 25.5536 19.3333 25.0013 19.3333H22.3346C21.7824 19.3333 21.3346 18.8856 21.3346 18.3333ZM4.66797 6.66667H4.68628C4.85209 5.16668 6.12378 4 7.66797 4H23.0013C24.6581 4 26.0013 5.34315 26.0013 7V8.11596C27.9124 8.5674 29.3346 10.2843 29.3346 12.3333V23.6667C29.3346 26.0599 27.3945 28 25.0013 28H9.0013C6.60808 28 4.66797 26.0599 4.66797 23.6667V6.66667ZM25.0013 10H6.66797V23.6667C6.66797 24.9553 7.71264 26 9.0013 26H25.0013C26.29 26 27.3346 24.9553 27.3346 23.6667V12.3333C27.3346 11.0447 26.29 10 25.0013 10ZM24.0013 8V7C24.0013 6.44772 23.5536 6 23.0013 6H7.66797C7.11569 6 6.66797 6.44772 6.66797 7C6.66797 7.55228 7.11569 8 7.66797 8H24.0013Z"
          fill="#EF6401"
        />
      </g>
    </svg>
  </i>
</ng-template>
